export const PROFESIONES = {
  'Enfermero/a': 1,
  Fisioterapeuta: 2,
};

export const getProfesionLabel = (value) => {
  if (value === 1) return 'Enfermero/a';
  if (value === 2) return 'Fisioterapeuta';
  return '';
};

export const getProfesionValue = (label) => PROFESIONES[label] || 0;
